import React from 'react'
import FilterButton from './filter-button'
import './active-filter.css'

const BulkFilterForm = ({filtering, handleChange, children}) => (
  <div className="bulkFilter--wrapper">
    {children}
    <form className="bulkFilter--toggles">
      <FilterButton
        label="Active"
        name="active"
        value={true}
        currentStatus={filtering}
        onChange={handleChange}
      /> 
      <FilterButton
        label="All"
        name="active"
        value={false}
        currentStatus={filtering}
        onChange={handleChange}
      />
    </form>
  </div>
)

export default BulkFilterForm


// WEBPACK FOOTER //
// ./src/ui/active-filter/view/index.jsx